import { createSelector } from 'reselect'

import type { LabelLink } from '@/types/app-types'

import type { LicensesResponse, LicensesStateType } from './types'

export const licensesSelector = createSelector(
    (state: LicensesStateType) => state.data,
    (data: LicensesResponse | undefined): LabelLink[] => {
        if (!data) return []
        if (!data.items.length) return [{ label: 'No Reseller License Numbers available' }]
        return data.items.map(({ license }) => ({
            label: license,
        }))
    },
)
